<template>
  <v-container class="pt-0" style="font-size: 0.9em">
    <v-row>
      <v-col>
        <h3
          class="d-flex justify-center multicritere--text"
          color="multicritere"
        >
          Recherche multi-critères
        </h3>
        <div>
          <p>Définissez vos propres critères et lancez la recherche.</p>
          <p>
            Vous pouvez cumuler plusieurs critères de choix. <br />
            En cas de sélection de différentes valeurs pour le même critère, les
            produits correspondant à une de ces valeurs au moins seront
            restitués.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
        md="3"
        lg="2"
        class="multicritere--text multicriterelighten1"
      >
        Vos critères
      </v-col>
      <v-col>
        <p v-if="criteresDefinis == null">
          Aucun critère sélectionné pour l'instant.
        </p>
        <v-container v-else>
          <v-row
            v-for="crit in Object.keys(this.criteresDefinis)"
            :key="crit"
            class="mb-1"
          >
            <span v-if="crit && crit.length > 0">
              <v-icon dark color="multicritere" @click="removeAllValues(crit)"
                >mdi-close-box-multiple</v-icon
              >

              {{
                criteresPossibles.find((c) => c.code == crit).intitule
              }}&nbsp;:
              <v-chip
                v-for="val in criteresDefinis[crit]"
                small
                close
                color="multicritere"
                dark
                class="ml-1"
                :key="val.id"
                @click:close="removeValue(crit, val.id)"
              >
                {{ val.libelle }}
              </v-chip>
            </span>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
        md="3"
        lg="2"
        class="multicritere--text multicriterelighten1"
      >
        Nouveau critère
      </v-col>
      <v-col>
        <v-card>
          <v-tabs v-model="activeTab" light color="multicritere">
            <v-tab
              v-for="critPossible in criteresPossibles"
              :key="critPossible.code"
            >
              {{ critPossible.intitule }}
            </v-tab>
          </v-tabs>
          <v-card-text v-if="critActif">
            <v-autocomplete
              v-model="acSaisie"
              :items="valeursPossibles"
              :loading="acLoading"
              :search-input.sync="acSearch"
              :label="valeurLabel"
              color="multicritere"
              hide-no-data
              hide-selected
              item-text="libelle"
              item-value="id"
              placeholder="saisissez du texte pour rechercher"
              prepend-icon="mdi-database-search"
              return-object
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center">
        <v-btn
          color="multicritere"
          large
          dark
          :to="{
            name: 'multiCriteresListe',
            params: { recherche: criteresDefinis, criteresPossibles },
          }"
        >
          <v-icon dark>mdi-magnify</v-icon>
          &nbsp; Voir les produits
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MultiCritsService from "@/services/MultiCritsService";

export default {
  name: "MultiCriteres",
  data() {
    return {
      criteresPossibles: [],
      criteresDefinis: null,
      activeTab: null,
      acLoading: false,
      acSearch: null,
      acSaisie: "",
      valeursPossibles: [],
    };
  },
  computed: {
    critActif() {
      if (this.activeTab == null) {
        return null;
      } else {
        return this.criteresPossibles[this.activeTab];
      }
    },
    valeurLabel() {
      return this.critActif.code == "frn" ? "Nom" : "Libellé";
    },
    // criteresDefinisAvecLibelles() {
    //   let result = {};
    //   if (this.criteresDefinis == null) return {};
    //   Object.keys(this.criteresDefinis).forEach((key) => {
    //     let index = this.criteresPossibles.findIndex(
    //       (item) => item.code == key
    //     );
    //     let lib = this.criteresPossibles[index].intitule;
    //     result[lib] = this.criteresDefinis[key];
    //   });
    //   return result;
    // },
    // currentCrits() {
    //   return Object.keys(this.criteresDefinis);
    // },
  },
  watch: {
    activeTab() {
      this.valeursPossibles = [];
    },
    acSearch(val) {
      if (val && val.trim() == "") return;
      // Items have already been loaded
      if (this.valeursPossibles.length > 0) return;

      // Items have already been requested
      if (this.acLoading) return;

      this.acLoading = true;

      // Lazily load input items
      MultiCritsService.getValeurs(
        this.critActif.code,
        val,
        this.criteresDefinis
      )
        .then((res) => {
          let valsDuCritere =
            this.criteresDefinis && this.criteresDefinis[this.critActif.code];
          if (valsDuCritere) {
            this.valeursPossibles = res.data.filter(
              (i) => !valsDuCritere.some((c) => c.id == i.id)
            );
          } else {
            this.valeursPossibles = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.acLoading = false));
    },
    acSaisie(val) {
      if (val != "") {
        this.ajouteValeur(val);
        this.$nextTick(() => {
          this.acSaisie = "";
        });
      }
    },
  },
  methods: {
    ajouteValeur(val) {
      let codeCritere = this.critActif.code;
      if (this.criteresDefinis == null) {
        this.criteresDefinis = {};
      }
      if (this.criteresDefinis[codeCritere] == undefined) {
        this.criteresDefinis[codeCritere] = [];
      }
      this.criteresDefinis[codeCritere].push({
        id: val.id,
        libelle: val.libelle,
      });
      //Retrait de la valeur des options de l'autocomplete
      let index = this.valeursPossibles.findIndex((i) => (i.id = val.id));
      this.valeursPossibles.splice(index);
    },
    removeAllValues(crit) {
      delete this.criteresDefinis[crit];
      this.valeursPossibles = [];
    },
    removeValue(crit, id) {
      let values = this.criteresDefinis[crit];
      if (values) {
        let index = values.findIndex((item) => item.id == id);
        values.splice(index, 1);
        if (values.length == 0) {
          delete this.criteresDefinis[crit];
        }
        this.valeursPossibles = [];
      }
    },
  },
  created() {
    MultiCritsService.getCriteresPossibles()
      .then((res) => {
        this.criteresPossibles = res.data;
        this.critEnCours = this.criteresPossibles[0];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style></style>
